// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-i[data-v-ec49c1dc] {\n  font-weight: 700;\n  font-size: 18px;\n  color: #000;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
